export default "__VITE_ASSET__yBZ70vKq__"